export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "v2.1088/checksum.worker.bundle.worker.js");
}
